import React,{useContext,useEffect, useState,useRef,useCallback,useMemo} from 'react';
import { getRequest, deleteRequest, tabulatorGet, downloadBlobGet, fetchTextGet } from '../../../api/ApiController';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css'
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon,EditRowIcon} from "../../svg/svgIcons";
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../../utils/tabulatorScroll';
import { resetTabulatorMask } from '../../../utils/tabulatorResetMask';
import { cleanSorters, parseSorters, parseMaskFilters, extractSafePaginationParams, createDedupedAjaxRequest, refreshProgressiveFromStart } from '../../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../../utils/pusherChannel';
import { inputOnEnterHeaderFilter } from '../../../utils/inputOnEnterHeaderFilter';
import { buildAuditTabulatorColumns } from '../../../utils/tabulatorAuditColumns';
import { buildTabulatorIdColumn } from '../../../utils/tabulatorIdColumn';
import PrintOptionsDialog from '../../../components/PrintOptionsDialog';
import { buildExportQueryStringFromParams, openPrintHtmlWindow, triggerBlobDownload } from '../../../utils/serviceTaskExport';
import {
  SUMMARY_EMAIL_OTK_MASK_PAGE,
  SUMMARY_EMAIL_OTK_REFRESH_EVENT,
  SUMMARY_EMAIL_OTK_PAGED_URL,
  SUMMARY_EMAIL_OTK_PRINT_URL,
  SUMMARY_EMAIL_OTK_XLSX_URL,
  SUMMARY_EMAIL_OTK_DEFAULT_COLUMN_VISIBILITY,
  SUMMARY_EMAIL_OTK_MASK_CONFIGURABLE_FIELDS,
  reconcileSummaryEmailOTKColumnVisibility,
  reconcileSummaryEmailOTKColumnLayout,
  getSummaryEmailOTKMaskFieldLabel,
  appendSummaryEmailOTKToolbarSearch,
} from '../../../utils/summaryEmailOTKListContract';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import { Avatar } from 'primereact/avatar';
import { LocaleContext } from '../../../components/LocaleContext';
import { applyTabulatorRuntimeI18n } from '../../../utils/tabulatorRuntimeI18n';
const SUMMARY_EMAIL_OTKLIST_COLUMN_I18N_KEYS = Object.freeze({
  'name': 'SummaryEmailOTKList.Column.Name',
  'custom_submodules': 'SummaryEmailOTKList.Column.Submodules',
  'status': 'SummaryEmailOTKList.Column.Type',
  'interval': 'SummaryEmailOTKList.Column.Interval',
  'regularity': 'SummaryEmailOTKList.Column.Regularity',
  'custom_regularity': 'SummaryEmailOTKList.Column.RegularityDetail',
  'email_time': 'SummaryEmailOTKList.Column.EmailTime',
  'custom_employees': 'SummaryEmailOTKList.Column.Employees',
  'custom_other_emails': 'SummaryEmailOTKList.Column.OtherEmails',
  'rowSelection': 'SummaryEmailOTKList.Column.Name',
});



const remoteHeaderFilterPassthrough = () => true;

export default function SummaryEmailOTKList(){

  const [state,dispatch] = useContext(DatabaseContext);
  const {user} = useContext(AuthContext);
  const { t, locale, dateFormatGlob, dateTimeFormatGlob, getUserColor, getUserInitials } = useContext(LocaleContext);
  const { openFavoriteDialog, toast, setFastView, setUserMaskFilter, setDialogText, setVisible , openChosenNotificationPreferences} = useContext(UtilContext);

    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [copyIcon,setCopyIcon] = useState(true);
    const [insertIcon,setInsertIcon] = useState(!user.permissions?.includes('add otk-setup'));

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    /** Submitted toolbar search — ref so Tabulator ajaxRequestFunc stale closure still emits toolbar_search. */
    const submittedSearchValueRef = useRef('');
    /** Remount key — full progressive session restart after toolbar search/cancel. */
    const [tableSessionKey, setTableSessionKey] = useState(0);

    const [searchIconColor,setSearchIconColor] = useState("");

    const [expandedKeys, setExpandedKeys] = useState({});

    const [markUnmark, setMarkUnmarked] = useState(true);
  
    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...SUMMARY_EMAIL_OTK_DEFAULT_COLUMN_VISIBILITY }));
    const [maskVisible, setMaskVisible] = useState(false);
    const [printChoiceVisible, setPrintChoiceVisible] = useState(false);
    const [printOrientationChoice, setPrintOrientationChoice] = useState('portrait');
    const [printLayoutChoice, setPrintLayoutChoice] = useState('fit');
const ref = useRef(null);
    const elementRef = useRef(null);
    const overlayRef = useRef(null);
    const tableBuiltRef = useRef(false);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const userInteractedRef = useRef(false);
    const isRestoringRef = useRef(false);

    const captureHScroll = () => {
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      if (!holder) return;
      savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    };
    const restoreHScroll = () => {
      if (!savedHScrollRef.current.pending) return;
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      const header = table.columnManager?.contentsElement;
      if (!holder) return;
      const left = savedHScrollRef.current.left;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          holder.scrollLeft = left;
          if (header) header.scrollLeft = left;
          savedHScrollRef.current.pending = false;
        });
      });
    };

    const pageSizePc = useMemo(() => {
      const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
      const n = parseInt(v, 10);
      return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);

    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingData') || t('Common.LoadingData')), [getTable, t]);
    const restartProgressiveSession = useCallback(() => {
      completedCacheRef.current.clear();
      inFlightRef.current = { sig: null, promise: null };
      tableBuiltRef.current = false;
      isRestoringRef.current = true;
      const table = getTable();
      // react-tabulator may keep progressive page cursor across replaceData after deep scroll.
      if (typeof table?.destroy === 'function') {
        try { table.destroy(); } catch (_e) { /* ignore */ }
      }
      ref.current = null;
      setTableSessionKey((key) => key + 1);
    }, [getTable]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
      const extra = { type: 'otk', ...extractSafePaginationParams(paramsFromTabulator) };
      if (extra.size == null) extra.size = pageSizePc;
      const t = getTable();
      const tableReadyForParams = tableBuiltRef.current;
      let hf = [];
      if (tableReadyForParams) hf = t?.getHeaderFilters?.() ?? [];
      if (tableReadyForParams && hf.length) {
        hf.forEach(f => {
          if (f?.field == null) return;
          const v = f.value;
          if (v === undefined || v === null || typeof v === 'object') return;
          const str = String(v).trim();
          if (str === '') return;
          extra[`filter_${f.field}`] = str;
        });
      } else if (!tableReadyForParams && state.user_mask_filters) {
        const maskRow = (state.user_mask_filters || []).find(m => m.page === SUMMARY_EMAIL_OTK_MASK_PAGE);
        if (maskRow) {
          parseMaskFilters(maskRow.filters).forEach(f => {
            if (!f?.field) return;
            const v = f.value;
            if (v === undefined || v === null || String(v).trim() === '') return;
            extra[`filter_${f.field}`] = v;
          });
        }
      }
      let sortersFromTable = [];
      if (tableReadyForParams) sortersFromTable = t?.getSorters?.() ?? [];
      const hasSorters = Array.isArray(sortersFromTable) && sortersFromTable.length > 0;
      if (hasSorters) {
        const clean = cleanSorters(sortersFromTable);
        if (clean.length > 0) extra.sorters = JSON.stringify(clean);
      } else if (!tableReadyForParams && state.user_mask_filters) {
        const maskRow = (state.user_mask_filters || []).find(m => m.page === SUMMARY_EMAIL_OTK_MASK_PAGE);
        if (maskRow?.sorters) {
          const parsed = parseSorters(maskRow.sorters);
          if (parsed.length > 0) extra.sorters = JSON.stringify(parsed.map(s => ({ field: s.field ?? s.column, dir: s.dir })));
        }
      }
      return appendSummaryEmailOTKToolbarSearch(extra, submittedSearchValueRef.current);
    }, [getTable, state.user_mask_filters, pageSizePc]);

  useEffect(() => {
    const onRefresh = () => {
      userInteractedRef.current = true;
      captureHScroll();
      refreshFromStart();
    };
    window.addEventListener(SUMMARY_EMAIL_OTK_REFRESH_EVENT, onRefresh);
    return () => window.removeEventListener(SUMMARY_EMAIL_OTK_REFRESH_EVENT, onRefresh);
  }, [refreshFromStart]);

  // Pusher secondary sync only — create/delete invalidate progressive session.
  useEffect(() => {
    const channel = getPusherChannel();
    if (!channel) return;
    const DEDUPE_MS = 800;
    const lastHandled = { key: '', at: 0 };
    const shouldSkip = (eventType, id) => {
      if (id == null) return true;
      const key = `${eventType}-${id}`;
      const now = Date.now();
      if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
      lastHandled.key = key;
      lastHandled.at = now;
      return false;
    };
    const onCreated = (data) => {
      const id = data?.id ?? null;
      if (id == null || shouldSkip('summary_email.created', id)) return;
      // SESSION_INVALIDATING_MUTATION — never addData into partial offset pages.
      refreshFromStart();
    };
    const onUpdated = (data) => {
      const id = data?.id ?? null;
      if (id == null || shouldSkip('summary_email.updated', id)) return;
      getRequest(`/api/summary_emails/${id}`).then((res) => {
        const rowData = res?.data ?? res;
        if (!rowData?.id) return;
        const table = getTable();
        const row = table?.getRow?.(rowData.id) ?? table?.getRows?.().find((r) => r.getData().id === id);
        if (rowData.type === 'otk') {
          if (row) row.update(rowData); // SESSION_SAFE_UPDATE for loaded row
          else refreshFromStart();
        } else if (row) {
          refreshFromStart();
        }
      }).catch(() => {});
    };
    const onDeleted = (data) => {
      const id = data?.id ?? null;
      if (id == null || shouldSkip('summary_email.deleted', id)) return;
      refreshFromStart();
    };
    channel.bind('summary_email.created', onCreated);
    channel.bind('summary_email.updated', onUpdated);
    channel.bind('summary_email.deleted', onDeleted);
    return () => {
      channel.unbind('summary_email.created', onCreated);
      channel.unbind('summary_email.updated', onUpdated);
      channel.unbind('summary_email.deleted', onDeleted);
    };
  }, [getTable, refreshFromStart]);

  function matchAny(data, filterParams) {
    //data - the data for the row being filtered
    //filterParams - params object passed to the filter
    //RegExp - modifier "i" - case insensitve

    var match = false;
    const regex = RegExp(filterParams.value, 'i');

    for (var key in data) {
        if (regex.test(data[key]) === true) {
            match = true;
        }
    }
    return match;
  }

    const accept = () => {
        const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
        rows_to_delete.forEach(element => {
          deleteRequest(`/api/summary_emails/${element.id}`)
              .then(() => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed') || 'Confirmed', life: 3000, detail: t('SummaryEmailOTKList.Toast.Deleted') || 'Deleted' });
                refreshFromStart();
              })
              .catch((reason) => {
                toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected') || 'Rejected', detail: t('SummaryEmailOTKList.Toast.DeleteFailed') || 'Delete failed', life: 3000 });
              });
        });
    }

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected') || 'Rejected', detail: t('Common.RequestCancelled') || 'Cancelled', life: 3000 });
    }

    const confirm = () => {
        confirmDialog({
            message: t('SummaryEmailOTKList.Confirm.DeleteMessage') || 'Delete this record?',
            header: t('SummaryEmailOTKList.Confirm.DeleteHeader') || 'Confirm delete',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.Yes') || 'Yes',
            rejectLabel: t('Common.No') || 'No',
            accept,
            reject
        });
    };

  const rowClick = (e, row) => {
    console.log(e, row);
 };

  const onSelectRow = (data, rows) => {
    setEditIcon(true);
    setCopyIcon(true);
    setDeleteIcon(true);
    const selected = getTable()?.getSelectedData?.() ?? [];
    if(selected.length>0){
      if(selected.length == 1){
        if(user.permissions?.includes('edit otk-setup'))setCopyIcon(false);
        if(user.permissions?.includes('edit otk-setup'))setEditIcon(false);
      }
      if(user.permissions?.includes('delete otk-setup'))setDeleteIcon(false);
    }
  };

  function onEditRow(summary_email){
    dispatch({type: 'create_new_tab', name: t('SummaryEmailOTKAdd.Tab.Title'), translationKey: 'SummaryEmailOTKAdd.Tab.Title', legacyLabel: t('SummaryEmailOTKAdd.Tab.Title') || t('Common.SummaryEmail'),page:'SummaryEmailOTKAdd',props:{summary_email: summary_email,type:'edit',not_last_used: true},mask:'qlty025'})
  };
  
  function EditRowFormatter(props) {
    const rowData = props.cell.getRow().getData();
    return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
  }

  function SubmodulesFormatter(props){
    const rowData = props.cell.getRow().getData();
    const parsed = parseSummaryData(rowData?.data);
    const submoduleData = Array.isArray(parsed?.data) ? parsed.data : [];
    if(submoduleData.length > 0){
      let submodules =  submoduleData.map((item) => item?.name).filter(Boolean).join('/');
      if(submodules.length > 20){
        return submodules.substring(0,20) + '...';
      }
      return submodules;
    }
    else{
      return null;
    }
  }

  function RegularityFormatter(props){
    const rowData = props.cell.getRow().getData();
    const parsed = parseSummaryData(rowData?.data);
    const period = Array.isArray(parsed?.time_period) ? parsed.time_period : [];
    if(period.length > 0){
      return period.map((item) => item?.name).filter(Boolean).join('/');
    }
    return null;
  }

  function parseSummaryData(rawData){
    if (!rawData) return {};
    if (typeof rawData === 'object') return rawData;
    if (typeof rawData !== 'string') return {};
    try {
      return JSON.parse(rawData);
    } catch (_e) {
      return {};
    }
  }

  function OtherEmailsFormatter(props){
    const rowData = props.cell.getRow().getData();
    if(rowData.other_emails){
      return rowData.other_emails.split(',').join('/');
    }
    else{
      return null;
    }
  }

  function EmployeesFormatter(props) {
    const rowData = props.cell.getRow().getData();
    let initials="";
    return rowData.employees.map((item) => {
      const allNames = item.name.trim().split(' ');
      if(allNames.length == 3){
        initials = allNames.reduce((acc, curr, index) => {
          if(index === allNames.length - 2 || index === allNames.length - 1){
            acc = `${acc}${curr.charAt(0).toUpperCase()}`;
          }
          return acc;
        }, '');
      }
      else{
        initials = allNames.reduce((acc, curr, index) => {
          if(index === 0 || index === allNames.length - 1){
            acc = `${acc}${curr.charAt(0).toUpperCase()}`;
          }
          return acc;
        }, '');
      }
      return <Avatar title={item.name} label={initials} shape="circle" style={{ backgroundColor: '#1d4ed8', color: '#ffffff',marginRight: '5px'}} />;
    });
  }

  function employeesHeaderFilter(headerValue, rowValue, rowData, filterParams){
    let employees = rowData.employees.map(item => item.name);
    for(let i = 0;i<employees.length;i++){
      let filter = headerValue.toLowerCase();
      let value = employees[i].toLowerCase();
      if(value.includes(filter)){
        return true;
      }
    }
    return false;
  }

  // OTKS1D: selection | edit | ID → business → audit (no drag)
  const auditTailColumns = useMemo(
    () =>
      buildAuditTabulatorColumns({
        includeId: false,
        dateFormat: dateFormatGlob,
        dateTimeFormat: dateTimeFormatGlob,
        getUserColor,
        getUserInitials,
        textHeaderFilter: remoteHeaderFilterPassthrough,
        remotePassthrough: true,
      }),
    [dateFormatGlob, dateTimeFormatGlob, getUserColor, getUserInitials]
  );

  const columns = useMemo(
    () => [
      {
        title: '',
        field: 'rowSelection',
        formatter: 'rowSelection',
        titleFormatter: 'rowSelection',
        hozAlign: 'center',
        width: 44,
        minWidth: 44,
        headerSort: false,
        headerFilter: false,
        resizable: false,
        frozen: true,
        print: false,
        download: false,
      },
      {
        title: '',
        field: 'editor',
        hozAlign: 'center',
        width: 44,
        minWidth: 44,
        headerSort: false,
        headerFilter: false,
        formatter: reactFormatter(<EditRowFormatter />),
        resizable: false,
        frozen: true,
        print: false,
        download: false,
      },
      buildTabulatorIdColumn({
        frozen: true,
        headerFilterFunc: remoteHeaderFilterPassthrough,
      }),
      {
        title: t('SummaryEmailOTKList.Column.Name') || t('Common.Name'),
        field: 'name',
        headerFilter: inputOnEnterHeaderFilter,
        headerFilterLiveFilter: false,
        headerFilterFunc: remoteHeaderFilterPassthrough,
        minWidth: 200,
      },
      {
        title: t('SummaryEmailOTKList.Column.Submodules') || 'Podmoduly',
        field: 'custom_submodules',
        headerFilter: inputOnEnterHeaderFilter,
        headerFilterLiveFilter: false,
        headerFilterFunc: remoteHeaderFilterPassthrough,
        minWidth: 200,
        formatter: reactFormatter(<SubmodulesFormatter />),
      },
      {
        title: t('SummaryEmailOTKList.Column.Type') || t('Common.Type'),
        field: 'status',
        headerFilter: inputOnEnterHeaderFilter,
        headerFilterLiveFilter: false,
        headerFilterFunc: remoteHeaderFilterPassthrough,
        minWidth: 200,
      },
      {
        title: t('SummaryEmailOTKList.Column.Interval') || 'Interval',
        field: 'interval',
        headerFilter: inputOnEnterHeaderFilter,
        headerFilterLiveFilter: false,
        headerFilterFunc: remoteHeaderFilterPassthrough,
        minWidth: 200,
      },
      {
        title: t('SummaryEmailOTKList.Column.Regularity') || t('Common.Frequency'),
        field: 'regularity',
        headerFilter: inputOnEnterHeaderFilter,
        headerFilterLiveFilter: false,
        headerFilterFunc: remoteHeaderFilterPassthrough,
        width: 220,
        minWidth: 220,
      },
      {
        title: t('SummaryEmailOTKList.Column.RegularityDetail') || t('Common.FrequencyDetail'),
        field: 'custom_regularity',
        headerFilter: inputOnEnterHeaderFilter,
        headerFilterLiveFilter: false,
        headerFilterFunc: remoteHeaderFilterPassthrough,
        width: 240,
        minWidth: 240,
        formatter: reactFormatter(<RegularityFormatter />),
      },
      {
        title: t('SummaryEmailOTKList.Column.EmailTime') || t('Common.EmailSendTime'),
        field: 'email_time',
        headerFilter: inputOnEnterHeaderFilter,
        headerFilterLiveFilter: false,
        headerFilterFunc: remoteHeaderFilterPassthrough,
        width: 240,
        minWidth: 240,
      },
      {
        title: t('SummaryEmailOTKList.Column.Employees') || 'Zamestnanci',
        field: 'custom_employees',
        headerFilter: inputOnEnterHeaderFilter,
        headerFilterLiveFilter: false,
        headerFilterFunc: remoteHeaderFilterPassthrough,
        minWidth: 200,
        formatter: reactFormatter(<EmployeesFormatter />),
      },
      {
        title: t('SummaryEmailOTKList.Column.OtherEmails') || t('Common.OtherEmails'),
        field: 'custom_other_emails',
        headerFilter: inputOnEnterHeaderFilter,
        headerFilterLiveFilter: false,
        headerFilterFunc: remoteHeaderFilterPassthrough,
        minWidth: 200,
        formatter: reactFormatter(<OtherEmailsFormatter />),
      },
      ...auditTailColumns,
    ],
    [t, auditTailColumns]
  );

  const exportQuerySuffix = useCallback(() => {
    const params = buildRequestParams({});
    return buildExportQueryStringFromParams(params, {
      print_columns: SUMMARY_EMAIL_OTK_MASK_CONFIGURABLE_FIELDS.filter((f) => columnsVisible[f] !== false),
    });
  }, [buildRequestParams, columnsVisible]);
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: SUMMARY_EMAIL_OTKLIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);


  const runServerPrint = useCallback(async () => {
    try {
      const suffix = exportQuerySuffix();
      const html = await fetchTextGet(`${SUMMARY_EMAIL_OTK_PRINT_URL}${suffix}&print_orientation=${printOrientationChoice}&print_layout=${printLayoutChoice}`);
      if (!openPrintHtmlWindow(html)) {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Error') || 'Error', detail: 'Print blocked', life: 3000 });
      }
    } catch (_e) {
      toast?.current?.show({ severity: 'warn', summary: t('Common.Error') || 'Error', detail: 'Print failed', life: 3000 });
    } finally {
      setPrintChoiceVisible(false);
    }
  }, [exportQuerySuffix, printOrientationChoice, printLayoutChoice, t, toast]);

  const runServerXlsx = useCallback(async () => {
    try {
      const suffix = exportQuerySuffix();
      const { blob, filename } = await downloadBlobGet(`${SUMMARY_EMAIL_OTK_XLSX_URL}${suffix}`, 'summary_emails_otk.xlsx');
      triggerBlobDownload(blob, filename || 'summary_emails_otk.xlsx');
    } catch (_e) {
      toast?.current?.show({ severity: 'warn', summary: t('Common.Error') || 'Error', detail: t('Common.ExportFailed'), life: 3000 });
    }
  }, [exportQuerySuffix, t, toast]);

  const scrollToFirst = () => scrollToFirstUtil(getTable());
  const scrollUp = () => scrollUpUtil(getTable());
  const scrollDown = () => scrollDownUtil(getTable());
  const scrollToLast = () => scrollToLastUtil(getTable());
  function addNewSummaryEmail(){
    dispatch({type: 'create_new_tab', name: t('SummaryEmailOTKAdd.Tab.Title'), translationKey: 'SummaryEmailOTKAdd.Tab.Title', legacyLabel: t('SummaryEmailOTKAdd.Tab.Title') || t('Common.SummaryEmail'),page:'SummaryEmailOTKAdd',props:{summary_email: null,type:'add'},mask:'qlty025'})
  }
  function copySummaryEmail(){
    const selected = getTable()?.getSelectedData?.() ?? [];
    if (selected.length > 0) dispatch({type: 'create_new_tab', name: t('SummaryEmailOTKAdd.Tab.Title'), translationKey: 'SummaryEmailOTKAdd.Tab.Title', legacyLabel: t('SummaryEmailOTKAdd.Tab.Title') || t('Common.SummaryEmail'),page:'SummaryEmailOTKAdd',props:{summary_email: selected[0],type:'add',not_last_used: true},mask:'qlty025'});
  }
  function editSummaryEmail(){
    const selected = getTable()?.getSelectedData?.() ?? [];
    if (selected.length > 0) dispatch({type: 'create_new_tab', name: t('SummaryEmailOTKAdd.Tab.Title'), translationKey: 'SummaryEmailOTKAdd.Tab.Title', legacyLabel: t('SummaryEmailOTKAdd.Tab.Title') || t('Common.SummaryEmail'),page:'SummaryEmailOTKAdd',props:{summary_email: selected[0],type:'edit',not_last_used: true},mask:'qlty025'});
  }

  function searchTable(){
    const normalized = String(searchValue ?? '').trim();
    submittedSearchValueRef.current = normalized;
    setSearchIconColor(normalized === '' ? '' : 'active');
    setVisibleSearch(false);
    captureHScroll();
    restartProgressiveSession();
  }

  function setMask(item,value){
    const columnVisible = reconcileSummaryEmailOTKColumnVisibility({ ...columnsVisible, [item]: value });
    const table = getTable();
    for (const field of SUMMARY_EMAIL_OTK_MASK_CONFIGURABLE_FIELDS) {
      if (columnVisible[field] === false) table?.hideColumn?.(field);
      else table?.showColumn?.(field);
    }
    table?.showColumn?.('id');
    setColumnsVisible(columnVisible);
  }
  
  function changeMarkings(value){
    const columnVisible = { ...SUMMARY_EMAIL_OTK_DEFAULT_COLUMN_VISIBILITY };
    const table = getTable();
    for (const field of SUMMARY_EMAIL_OTK_MASK_CONFIGURABLE_FIELDS) {
      columnVisible[field] = !!value;
      if (value) table?.showColumn?.(field);
      else table?.hideColumn?.(field);
    }
    columnVisible.id = true;
    table?.showColumn?.('id');
    setColumnsVisible(reconcileSummaryEmailOTKColumnVisibility(columnVisible));
  }
  
  const itemRenderer = (item, options) => (
    <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
        <span className={`${item.icon} text-primary`} />
        <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
        {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
    </a>
  );
  
  
  const handleClickOutside = (event) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setExpandedKeys({});
    }
  };
  
  useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
          document.removeEventListener('click', handleClickOutside, true);
      };
  }, []);

  const resetMask = () => resetTabulatorMask({
    page: SUMMARY_EMAIL_OTK_MASK_PAGE,
    defaultColumnsVisible: { ...SUMMARY_EMAIL_OTK_DEFAULT_COLUMN_VISIBILITY },
    ref, columns, setColumnsVisible,
  });

  const maskDialogFields = useMemo(
    () => SUMMARY_EMAIL_OTK_MASK_CONFIGURABLE_FIELDS.map((field) => ({
      field,
      title: columns.find((c) => c.field === field)?.title
        || getSummaryEmailOTKMaskFieldLabel(field, t),
    })),
    [columns, t]
  );

    const items = [
    {
      key: '0',
      label: t('Common.Actions') || t('Common.Actions'),
      icon: 'pi pi-sliders-v',
      template: itemRenderer,
      items: [
            {
              key: '0_1',
              label: t('Common.SetFilter') || t('Common.SetFilter'),
              icon: 'pi pi-filter',
              command: () => {setUserMaskFilter(SUMMARY_EMAIL_OTK_MASK_PAGE,"set_filters",null,getTable()?.getHeaderFilters?.() ?? [],null); refreshFromStart();},
              template: itemRenderer,
          },
            {
              key: '0_2',
              label: t('Common.ClearFilter') || t('Common.ClearFilter'),
              icon: 'pi pi-filter-slash',
              command: () => {setUserMaskFilter(SUMMARY_EMAIL_OTK_MASK_PAGE,"set_filters",null,[],null); getTable()?.clearHeaderFilter?.(); refreshFromStart();},
              template: itemRenderer,
          },
          {
              key: '0_3',
              label: t('Common.SetSorting') || 'Nast. triedenie',
              icon: 'pi pi-sort-alt',
              command: () => {setUserMaskFilter(SUMMARY_EMAIL_OTK_MASK_PAGE,"set_sorters",null,null,null,getTable()?.getSorters?.() ?? []);OverflowMenuProvider.setVisible(null);setExpandedKeys({}); refreshFromStart();},
              template: itemRenderer,
          },
          {
              key: '0_4',
              label: t('Common.ClearSorting') || t('Common.ClearSorting'),
              icon: 'pi pi-sort-alt-slash',
              command: () => {setUserMaskFilter(SUMMARY_EMAIL_OTK_MASK_PAGE,"set_sorters",null,null,null,[]); getTable()?.setSort?.([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({}); refreshFromStart();},
              template: itemRenderer,
          },
          {
              key: '0_5',
              label: t('Common.SetMask') || t('Common.SetMask'),
              icon: 'pi pi-server',
              command: () => {
                setColumnsVisible(reconcileSummaryEmailOTKColumnVisibility(columnsVisible));
                setMaskVisible(true);
                OverflowMenuProvider.setVisible(null);
                setExpandedKeys({});
              },
              template: itemRenderer,
          },
          {
              key: '0_5b',
              label: t('Common.ResetUserMask') || 'Reset masky',
              icon: 'pi pi-refresh',
              command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
              template: itemRenderer,
          },
          {
            key: '0_6',
            label: t('Common.Notifications') || t('Common.Notifications'),
            icon: 'pi pi-envelope',
            command: () => {openChosenNotificationPreferences('InternaChyba');OverflowMenuProvider.setVisible(null);},
            template: itemRenderer,
        },
      ]
    }
  ];return(
      <>
      <div className='w-full h-10 flex flex-row bg-[#333]'>
      <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><button className="disabled:opacity-25" disabled={insertIcon} onClick={() => addNewSummaryEmail()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editSummaryEmail()}><EditIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copySummaryEmail()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button type="button" onClick={() => setPrintChoiceVisible(true)} title={t('Common.Print')}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="search"><button onClick={searchIconColor!="active"? () => {setVisibleSearch(true);}:() => {setSearchIconColor("");setSearchValue(""); submittedSearchValueRef.current = ''; restartProgressiveSession();}}>{searchIconColor == "" ?  <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search') || t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch') || t('Common.CancelSearch')}/>}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="export"><button type="button" onClick={() => { void runServerXlsx(); }} title={t('Common.Export')}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="refresh"><button onClick={() => { userInteractedRef.current = true; captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="tofirst"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="toup"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="todown"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="tolast"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="favorite"><button onClick={() => openFavoriteDialog(t('SummaryEmailOTKList.FavoriteTitle') || t('Common.NewSummaryEmail'),"SummaryEmailList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="fast"><button onClick={() => setFastView("SummaryEmailList",null,null)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100] " data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
        </IntersectionObserverWrapper>
      </div>
<div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    <div ref={elementRef}>
      <ReactTabulator
      key={tableSessionKey}
      data={undefined}
      className='h-[calc(100vh_-_193px)]'
      onRef={(r) => (ref.current = r?.current)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          tableBuiltRef.current = true;
          const table = getTable();
          const mask = (state.user_mask_filters || []).filter((m) => m.page === SUMMARY_EMAIL_OTK_MASK_PAGE);
          const safeParse = (v, fallback) => {
            if (v === null || v === undefined) return fallback;
            if (typeof v === 'string') { try { return JSON.parse(v); } catch { return fallback; } }
            return v;
          };
          isRestoringRef.current = true;
          if (mask.length > 0 && table) {
            const attributes = reconcileSummaryEmailOTKColumnLayout(safeParse(mask[0].attributes, []));
            const filters = safeParse(mask[0].filters, []);
            const sorters = safeParse(mask[0].sorters, []);
            const json_columns = reconcileSummaryEmailOTKColumnVisibility(safeParse(mask[0].columns, {}));
            if (Array.isArray(attributes) && attributes.length > 1) table.setColumnLayout(attributes);
            if (Array.isArray(filters)) filters.forEach((f) => table.setHeaderFilterValue(f.field, f.value));
            if (Array.isArray(sorters) && sorters.length > 0) table.setSort(sorters);
            setColumnsVisible(json_columns);
            for (const column of SUMMARY_EMAIL_OTK_MASK_CONFIGURABLE_FIELDS) {
              if (json_columns[column] === false) table.hideColumn?.(column);
              else table.showColumn?.(column);
            }
            table.showColumn?.('id');
            refreshFromStart();
          } else if (table) {
            const defaults = reconcileSummaryEmailOTKColumnVisibility(null);
            setColumnsVisible(defaults);
            for (const column of SUMMARY_EMAIL_OTK_MASK_CONFIGURABLE_FIELDS) {
              if (defaults[column] === false) table.hideColumn?.(column);
              else table.showColumn?.(column);
            }
            table.showColumn?.('id');
          }
          setTimeout(() => { isRestoringRef.current = false; }, 0);
        },
        headerFilterChanged: () => {
          if (!isRestoringRef.current) userInteractedRef.current = true;
          captureHScroll();
          refreshFromStart();
        },
        sortChanged: () => {
          if (isRestoringRef.current) return;
          userInteractedRef.current = true;
          captureHScroll();
          refreshFromStart();
        },
        columnMoved: () => setUserMaskFilter(SUMMARY_EMAIL_OTK_MASK_PAGE,"column_move",null,null,getTable()?.getColumnLayout?.()),
        columnResized: () => setUserMaskFilter(SUMMARY_EMAIL_OTK_MASK_PAGE,"column_move",null,null,getTable()?.getColumnLayout?.()),
        renderComplete: () => restoreHScroll(),
      }}
      options={{
        layout:"fitColumns", renderHorizontal:"virtual", rowHeight: 42, movableColumns: true,
        ajaxURL: SUMMARY_EMAIL_OTK_PAGED_URL,
        ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        ajaxRequesting: () => {
          if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
          const table = getTable();
          if (table?.initialized) table.alert?.(t('Common.LoadingData') || t('Common.LoadingData'));
          return true;
        },
        ajaxResponse: (_url, _params, response) => {
          getTable()?.clearAlert?.();
          return response;
        },
        ajaxError: () => {
          getTable()?.clearAlert?.();
        },
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData') || t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed') || t('Common.LoadFailed'),
        placeholder: t('Common.NoData') || t('Common.NoData'),
        progressiveLoad: 'scroll',
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePc,
        filterMode: 'remote',
        sortMode: 'remote',
        pagination: false,
        initialSort: [{ column: 'id', dir: 'desc' }],
      }}/> 
    </div> 
  </div> 
</div> 
</div>
          <Dialog header={t('Common.SearchInList') || t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <PrintOptionsDialog
            visible={printChoiceVisible}
            onHide={() => setPrintChoiceVisible(false)}
            orientation={printOrientationChoice}
            onOrientationChange={setPrintOrientationChoice}
            layout={printLayoutChoice}
            onLayoutChange={setPrintLayoutChoice}
            onConfirm={() => { void runServerPrint(); }}
          />
          <Dialog header={t('Common.SetMask') || t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? (t('Common.UnmarkAll') || t('Common.DeselectAllUpper')) : (t('Common.MarkAll') || t('Common.SelectAllUpper'))}</button>
        {maskDialogFields.map((item) => (
          <div key={item.field} className="flex flex-row border border-black rounded-md p-2 m-1">
            <Checkbox onChange={(e) => setMask(item.field, e.checked)} checked={columnsVisible[item.field] !== false} />
            <span className="ml-2">{item.title}</span>
          </div>
        ))}
                 <button onClick={() => {
                   const normalized = reconcileSummaryEmailOTKColumnVisibility(columnsVisible);
                   setColumnsVisible(normalized);
                   setUserMaskFilter(SUMMARY_EMAIL_OTK_MASK_PAGE,"set_columns",normalized,null,null);
                   setMaskVisible(false);
                 }} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Common.Save') || 'ULOŽIŤ'}</button>
        </div>
      </Dialog>
      
      </div> 
 </>
    )

}